/**
 * Financial Test Card — quick 2-question quiz that returns a saver profile.
 */
import React from 'react';
import { PieChart } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const TestCard = ({ testAnswers, setTestAnswers, testResult, handleTest }) => (
  <Card className="tool-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <PieChart className="w-6 h-6 text-neon" />
        Test Financiero
      </CardTitle>
      <CardDescription>2 preguntas brutalmente honestas. Sin filtros, sin excusas 🔍</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <label className="input-label">Cuando me cae la quincena…</label>
        <select
          className="input-select"
          value={testAnswers.q1}
          onChange={(e) => setTestAnswers({ ...testAnswers, q1: e.target.value })}
          data-testid="test-q1-select"
        >
          <option value="">Elige (con la verdad por delante)</option>
          <option value="1">Se evapora en 72 horas, ni sé en qué</option>
          <option value="2">Algo guardo… cuando me acuerdo</option>
          <option value="3">Lo invierto antes de tocarlo</option>
        </select>
      </div>
      <div>
        <label className="input-label">% que realmente ahorras hoy</label>
        <select
          className="input-select"
          value={testAnswers.q2}
          onChange={(e) => setTestAnswers({ ...testAnswers, q2: e.target.value })}
          data-testid="test-q2-select"
        >
          <option value="">Elige (otra vez, sin maquillarlo)</option>
          <option value="1">0% — vivo el momento (y la deuda)</option>
          <option value="2">Menos del 10% — algo es algo</option>
          <option value="3">10% o más — sí soy esa persona</option>
        </select>
      </div>
      <Button onClick={handleTest} className="w-full button-neon" data-testid="test-submit">
        Diagnóstico, por favor
      </Button>
      {testResult && (
        <div className="test-result" style={{ borderColor: testResult.color }} data-testid="test-result">
          <h4 style={{ color: testResult.color }}>{testResult.profile}</h4>
          <p className="text-gray-300 mt-2">{testResult.description}</p>
          <p className="text-sm text-gray-400 mt-3">
            <strong>Receta:</strong> {testResult.recommendation}
          </p>
        </div>
      )}
    </CardContent>
  </Card>
);

export default TestCard;
